import type { DeepPartial } from "@apollo/client/utilities";

import { AdditionalHookOptions } from "./types";

type Options<TData = unknown> = AdditionalHookOptions<TData> & {
  skip?: boolean;
};

// Structural rather than useQuery.Result/useLazyQuery.Result: this is called with results from
// both hooks, and only ever reads `error`/`data`, which both namespaced Result types share.
type PollResult<TData> = {
  error?: unknown;
  data?: TData | DeepPartial<TData>;
};

const shouldPoll = <TData = unknown>(options: Options<TData>, result?: PollResult<TData>) => {
  if (options.skip) {
    return false;
  }

  if (result?.error) {
    return false;
  }

  if (options.shouldPoll) {
    return options.shouldPoll(result?.data);
  }

  return true;
};

export default shouldPoll;
